import React from "react";
import { Navigate } from "react-router-dom";
import { getUser } from "./auth";

const RoleRoute = ({ children, role }) => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== role) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RoleRoute;